export const colors = {
  BOLDNESS: "boldness",
  FREEDOM: "freedom",
  freedom: "freedom",
  BOLD_DARK: "boldness",
  STRATEGY_RED: "strategy-red",
  STRATEGY_GOLD: "strategy-gold",
  STRATEGY_GREEN: "strategy-green",
};
